module.exports = __webpack_public_path__ + "img/tu1.23cd6564.png";